/**
 * Gera um link do WhatsApp a partir do número e da mensagem
 * @param number Número do WhatsApp no formato qualquer (ex: "(41) 99855-8610")
 * @param message Mensagem que será enviada (opcional)
 * @returns URL para abrir o WhatsApp
 */
export function generateWhatsAppLink(number: string, message?: string): string {
  if (!number) return "#"

  // Remove tudo que não é número
  const phone = number.replace(/\D/g, "")

  // Mensagem padrão se não for fornecida
  const text = encodeURIComponent(message || "Olá, gostaria de mais informações.")

  return `https://wa.me/${phone}?text=${text}`
}

export function numberReplace(number: string) {
  if (!number) return "#"

  // Remove tudo que não é número
  const phone = number.replace(/\D/g, "")

  return phone
}